import { LICENSE_PLAN_KEY, LICENSE_PLAN_STATUS } from './constant';
import useLicense from './useLicense';

export default useLicense;

export { LICENSE_PLAN_KEY, LICENSE_PLAN_STATUS };
